import { render, staticRenderFns } from "./opintoopas.vue?vue&type=template&id=7820b788&scoped=true&"
import script from "./opintoopas.vue?vue&type=script&lang=ts&"
export * from "./opintoopas.vue?vue&type=script&lang=ts&"
import style0 from "./opintoopas.vue?vue&type=style&index=0&id=7820b788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7820b788",
  null
  
)

export default component.exports